/*
 * File: UpdateCourseCompletionCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createMutation } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type UpdateCourseCompletionCriteriaParams = {
  courseId: string;
  policy: {
    performance_time_required: PostGreSQLInterval | null;
    observation_time_required: PostGreSQLInterval | null;
  };
};

export type UpdateCourseCompletionCriteriaResult = boolean;

async function updateCourseCompletionCriteria(
  params: UpdateCourseCompletionCriteriaParams,
): Promise<UpdateCourseCompletionCriteriaResult> {
  // make api call
  const result = await privateApi.put(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/completionCriteria`,
    params.policy,
  );

  // return the data object
  return result.data;
}

const useUpdateCourseCompletionCriteria = createMutation({
  mutationFn: async (variables: UpdateCourseCompletionCriteriaParams) => updateCourseCompletionCriteria(variables),
});

export { updateCourseCompletionCriteria, useUpdateCourseCompletionCriteria };
